<template>
  <div v-if="showComponent"
       :title="qaAble ? showIfHasPermission?.toString() : null"
       :key="componentRefresh">
    <nav class="navbar navbar-expand-lg border-bottom justify-content-between" :class="[classes]" :style="styles">
      <button v-if="showCollapseMenu" class="navbar-toggler" type="button" data-toggle="collapse"
              :data-target="`#${target}`" :aria-controls="`${target}`" aria-expanded="false"
              aria-label="Toggle navigation"
              style="padding: .25rem !important;">
        <span class="navbar-toggler-icon"></span>
      </button>
      <!--      flex-fill-->
      <a class="navbar-brand" :href="path ? path : ''" :class="screenSizeId < 3 ? 'mobile-brand' : ''">
        <slot name="title"></slot>
        <template v-if="!hasSlotTitle">
          <img :src="logo.src" :width="logo.width" :height="logo.height" :class="[logo.class]" alt="" v-if="logo.src">
          {{ title }}
          <span class="text-muted menu-version" style="" v-if="version !== null">{{ version }}</span>
        </template>
      </a>
      <slot></slot>
    </nav>
  </div>
</template>


<script>
import checkPermissions from '../../mixins/checkPermissions';

export default {

  name: "menu-bar",
  mixins: [checkPermissions],
  props: {
    target: {
      type: String,
      required: false
    },
    title: {
      type: String,
      default: ''
    },
    version: {
      type: String,
      default: null
    },
    classes: {
      type: String,
      default: "navbar-light bg-light"
    },
    styles: {
      type: Object
    },
    logo: {
      type: Object,
      default: () => {
        return {
          width: '30',
          height: '30',
          class: 'd-inline-block align-top',
          src: null
        }
      }
    },
    path: {
      type: String,
      default: null
    },
    showCollapseMenu: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    '$route': function () {
      $(`#${this.target}`).collapse('hide');
    }
  },
  computed: {
    hasSlotTitle() {
      return !!this.$slots.title;
    },
    screenSizeId() {
      return app.layout.screenSizeId;
    },
    qaAble: {
      get: () => {
        return app.store.state.ks_app.global_data.qaAble;
      }
    }
  }
}
</script>
<style scoped>
.mobile-brand {
  margin-right: 5px !important;
  margin-left: 5px !important;
}
</style>
